module.exports = __webpack_public_path__ + "img/image11.12bd52bd.png";